import { Component } from '@angular/core';

/**
 * A loading screen that shows the fusus spindle with a circuit on a dark background.
 *
 * There is duplicated HTML in the index.html files so that the loader screen shows ASAP.
 *
 * First, the index.html file is sent to the client. The loader-screen.css from the global assets/
 * folder applies a dark background. The loader spinner .gif is then downloaded.
 *
 * Next, Angular bootstraps the application component into the root tag.
 *
 * Additional loading may occur while components are loading -- that's where this component is
 * used.
 */
@Component({
  selector: 'fs-loader-screen',
  templateUrl: './loader-screen.component.html',
  styleUrls: ['../../../../../../../assets/fusus-icons/css/loader-screen.css'],
})
export class FsLoaderScreenComponent {
  constructor() {}
}
